import { render } from "./OnlineStore.vue?vue&type=template&id=220fa85b&scoped=true"
import script from "./OnlineStore.vue?vue&type=script&lang=js"
export * from "./OnlineStore.vue?vue&type=script&lang=js"

import "./OnlineStore.vue?vue&type=style&index=0&id=220fa85b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220fa85b"]])

export default __exports__